export default __webpack_public_path__ + "images/8D.cb6e6ce.png";